import { Injectable } from "@angular/core";
import { Plan } from "../components/plan/plan";

export interface BillingInfo {
  hasGST: boolean;
  gstNumber?: string;
  country: string;
  state?: string;
  district?: string;
  addressLine: string;
  pinCode?: string;
  gymName?: string;
  subId?: string;
}

@Injectable({
  providedIn: "root",
})
export class PaymentStateService {
  // Step 1 data
  selectedPlan: Plan | null = null;
  selectedBranchId: string | null = null;
  isInternationalPayment: boolean = false;

  // Step 2 data
  billingInfo: BillingInfo | null = null;

  // Data setters
  setPlanData(plan: Plan, branchId: string, isInternational: boolean): void {
    this.selectedPlan = plan;
    this.selectedBranchId = branchId;
    this.isInternationalPayment = isInternational;
  }

  setBillingInfo(billingInfo: BillingInfo): void {
    this.billingInfo = billingInfo;
  }

  // Validation helpers
  isStep1Complete(): boolean {
    return !!(this.selectedPlan && this.selectedBranchId);
  }

  isStep2Complete(): boolean {
    return !!(this.billingInfo && this.billingInfo.addressLine);
  }
}
